import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DateUtils } from '../../../helper/date-utils';

@Component({
    selector: 'app-data-selector',
    templateUrl: './data-selector.component.html',
    styleUrls: ['./data-selector.component.scss']
})
export class DataSelectorComponent implements OnInit {
    @Input() readonly: boolean = false;
    @Input() value: string | Date;
    @Input() viewMode: 'view' | 'select' = 'select';
    @Input() description: string;
    @Input() label: string;
    @Input() icon: string;
    @Input() withDefault: boolean = true;
    @Input() placeholder: string;

    @Output() changed = new EventEmitter<string>();

    selectedDate: string;
    selectedDateMenu: Date;

    public ngOnInit(): void {
        if (this.value) {
            this.selectedDate = (this.value instanceof Date) ? this.value.toLocaleDateString('pt-BR') : (DateUtils.parseDate(this.value) as Date).toLocaleDateString('pt-BR')
        } else if (this.withDefault) {
            this.selectedDate = new Date().toLocaleDateString('pt-BR');
        }
        if (this.selectedDate) {
            this.selectedDateMenu = DateUtils.parseDate(this.selectedDate) as Date;
            this.emitEvent();
        }
    }

    private emitEvent() {
        this.changed.emit((DateUtils.parseDate(this.selectedDate) as Date).toISOString() as string);
    }

    public eventDateChanged(): void {
        const date = DateUtils.parseDate(this.selectedDate);
        if (date) {
            this.selectedDateMenu = date;
        }
        this.emitEvent();
    }
    public eventDateChangedFromMenu(): void {
        this.selectedDate = new Date(this.selectedDateMenu).toLocaleDateString();
        this.emitEvent();
    }
}
